export default "__VITE_ASSET__B7wg19mz__"